<div class="input-wrapper__content h-100">
    <molecule-input-lookup
        [isMulti]="isMulti"
        [initialValue]="initialValue"
        [formInputData]="formInputData"
        [validationErrorMessage]="validationErrorMessage"
        [formData]="formData"
        [formContext]="formContext"
        (valueChanged)="onValueChanged($event)"
        (deleteItem)="onRemove($event)"
        (blurred)="onBlur()"
    >
    </molecule-input-lookup>
</div>
